import * as tslib_1 from "tslib";
import { Item } from './item';
import { Value } from './value';
import { StringInput } from './input';
import { Murmur3 } from './murmur3';
var Text = (function (_super) {
    tslib_1.__extends(Text, _super);
    function Text(value, flags) {
        var _this = _super.call(this) || this;
        _this._value = value;
        _this._flags = flags;
        return _this;
    }
    Object.defineProperty(Text.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "size", {
        get: function () {
            return this._value.length;
        },
        enumerable: true,
        configurable: true
    });
    Text.prototype.isIdent = function () {
        var cs = new StringInput(this._value);
        if (cs.isEmpty() || !Item.Recon.isIdentStartChar(cs.head())) {
            return false;
        }
        cs.step();
        while (!cs.isEmpty() && Item.Recon.isIdentChar(cs.head())) {
            cs.step();
        }
        return cs.isEmpty();
    };
    Text.prototype.isDone = function () {
        return false;
    };
    Text.prototype.isFull = function () {
        return false;
    };
    Text.prototype.push = function () {
        var cs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            cs[_i] = arguments[_i];
        }
        if ((this._flags & Text.IMMUTABLE) !== 0) {
            throw new Error('immutable');
        }
        for (var i = 0, n = cs.length; i < n; i += 1) {
            var c = cs[i];
            if (typeof c === 'number') {
                if ((c >= 0x0000 && c <= 0xD7FF) || (c >= 0xE000 && c <= 0xFFFF)) {
                    this._value += String.fromCharCode(c);
                }
                else if (c >= 0x10000 && c <= 0x10FFFF) {
                    var u = c - 0x10000;
                    this._value += String.fromCharCode(0xD800 | (u >>> 10), 0xDC00 | (u & 0x3FF));
                }
                else {
                    this._value += String.fromCharCode(0xFFFD);
                }
            }
            else if (typeof c === 'string') {
                var cs_1 = new StringInput(c);
                while (!cs_1.isEmpty()) {
                    this.push(cs_1.head());
                    cs_1.step();
                }
            }
        }
    };
    Text.prototype.isMutable = function () {
        return (this._flags & Text.IMMUTABLE) === 0;
    };
    Text.prototype.branch = function () {
        return this.clone();
    };
    Text.prototype.clone = function () {
        return new Text(this._value, 0);
    };
    Text.prototype.commit = function () {
        this._flags |= Text.IMMUTABLE;
        return this;
    };
    Text.prototype.bind = function () {
        return this;
    };
    Text.prototype.stringValue = function () {
        return this._value;
    };
    Text.prototype.numberValue = function () {
        var value = +this._value;
        if (isFinite(value)) {
            return value;
        }
        return undefined;
    };
    Text.prototype.toAny = function () {
        return this._value;
    };
    Text.prototype.valueOf = function () {
        return this._value;
    };
    Text.prototype.writeRecon = function (output) {
        if (this.isIdent()) {
            Text.writeIdent(this._value, output);
        }
        else {
            Text.writeString(this._value, output);
        }
    };
    Text.writeIdent = function (s, output) {
        var cs = new StringInput(s);
        while (!cs.isEmpty()) {
            output.push(cs.head());
            cs.step();
        }
    };
    Text.writeString = function (s, output) {
        var cs = new StringInput(s);
        output.push(34);
        while (!cs.isEmpty()) {
            var c = cs.head();
            switch (c) {
                case 34:
                case 92:
                    output.push(92, c);
                    break;
                case 8:
                    output.push(92, 98);
                    break;
                case 12:
                    output.push(92, 102);
                    break;
                case 10:
                    output.push(92, 110);
                    break;
                case 13:
                    output.push(92, 114);
                    break;
                case 9:
                    output.push(92, 116);
                    break;
                default:
                    output.push(c);
            }
            cs.step();
        }
        output.push(34);
    };
    Text.writeMarkup = function (s, output) {
        var cs = new StringInput(s);
        while (!cs.isEmpty()) {
            var c = cs.head();
            switch (c) {
                case 36:
                case 64:
                case 91:
                case 92:
                case 93:
                case 123:
                case 125:
                    output.push(92, c);
                    break;
                case 8:
                    output.push(92, 98);
                    break;
                case 12:
                    output.push(92, 102);
                    break;
                case 10:
                    output.push(92, 110);
                    break;
                case 13:
                    output.push(92, 114);
                    break;
                case 9:
                    output.push(92, 116);
                    break;
                default:
                    output.push(c);
            }
            cs.step();
        }
    };
    Text.prototype.compare = function (that) {
        if (that instanceof Text) {
            var order = this._value.localeCompare(that._value);
            return order < 0 ? -1 : order > 0 ? 1 : 0;
        }
        else if (that instanceof Item.Field || that instanceof Item.Record
            || that instanceof Item.Data) {
            return 1;
        }
        else {
            return -1;
        }
    };
    Text.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof Text) {
            return this._value === that._value;
        }
        return false;
    };
    Text.prototype.hashCode = function () {
        return Murmur3.hash(this._value);
    };
    Text.prototype.toString = function () {
        return this._value;
    };
    Text.empty = function () {
        return new Text('', 0);
    };
    Text.valueOf = function (value) {
        if (value.length === 0) {
            return Text.Empty;
        }
        else {
            return new Text(value, Text.IMMUTABLE);
        }
    };
    Text.of = function (value) {
        if (value instanceof Text) {
            return value;
        }
        else if (typeof value === 'string') {
            return Text.valueOf(value);
        }
        else {
            throw new TypeError('' + value);
        }
    };
    Text.IMMUTABLE = 1;
    Text.Empty = new Text('', Text.IMMUTABLE);
    return Text;
}(Value));
export { Text };
Item.Text = Text;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxJQUFJLEVBQUMsTUFBTSxRQUFRLENBQUM7QUFDNUIsT0FBTyxFQUFXLEtBQUssRUFBQyxNQUFNLFNBQVMsQ0FBQztBQUN4QyxPQUFPLEVBQUMsV0FBVyxFQUFDLE1BQU0sU0FBUyxDQUFDO0FBRXBDLE9BQU8sRUFBQyxPQUFPLEVBQUMsTUFBTSxXQUFXLENBQUM7QUFJbEM7SUFBMEIsZ0NBQUs7SUFNN0IsY0FBb0IsS0FBYSxFQUFFLEtBQWE7UUFBaEQsWUFDRSxpQkFBTyxTQUdSO1FBRkMsS0FBSSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUM7UUFDcEIsS0FBSSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUM7O0lBQ3RCLENBQUM7SUFFRCxzQkFBSSx1QkFBSzthQUFUO1lBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDckIsQ0FBQzs7O09BQUE7SUFFRCxzQkFBSSxzQkFBSTthQUFSO1lBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQzVCLENBQUM7OztPQUFBO0lBRUQsc0JBQU8sR0FBUDtRQUNFLElBQU0sRUFBRSxHQUFHLElBQUksV0FBVyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUN4QyxFQUFFLENBQUMsQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLGdCQUFnQixDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUM1RCxNQUFNLENBQUMsS0FBSyxDQUFDO1FBQ2YsQ0FBQztRQUNELEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNWLE9BQU8sQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUUsQ0FBQztZQUMxRCxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDWixDQUFDO1FBQ0QsTUFBTSxDQUFDLEVBQUUsQ0FBQyxPQUFPLEVBQUUsQ0FBQztJQUN0QixDQUFDO0lBRUQscUJBQU0sR0FBTjtRQUNFLE1BQU0sQ0FBQyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRUQscUJBQU0sR0FBTjtRQUNFLE1BQU0sQ0FBQyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRUQsbUJBQUksR0FBSjtRQUFLLFlBQTBCO2FBQTFCLFVBQTBCLEVBQTFCLHFCQUEwQixFQUExQixJQUEwQjtZQUExQix1QkFBMEI7O1FBQzdCLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUN6QyxNQUFNLElBQUksS0FBSyxDQUFDLFdBQVcsQ0FBQyxDQUFDO1FBQy9CLENBQUM7UUFDRCxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7WUFDN0MsSUFBTSxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2hCLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUM7Z0JBQzFCLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLE1BQU0sSUFBSSxDQUFDLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsSUFBSSxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7b0JBQ2pFLElBQUksQ0FBQyxNQUFNLElBQUksTUFBTSxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDeEMsQ0FBQztnQkFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sSUFBSSxDQUFDLElBQUksUUFBUSxDQUFDLENBQUMsQ0FBQztvQkFDekMsSUFBTSxDQUFDLEdBQUcsQ0FBQyxHQUFHLE9BQU8sQ0FBQztvQkFDdEIsSUFBSSxDQUFDLE1BQU0sSUFBSSxNQUFNLENBQUMsWUFBWSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRSxNQUFNLEdBQUcsQ0FBQyxDQUFDLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQztnQkFDaEYsQ0FBQztnQkFBQyxJQUFJLENBQUMsQ0FBQztvQkFDTixJQUFJLENBQUMsTUFBTSxJQUFJLE1BQU0sQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLENBQUM7Z0JBQzdDLENBQUM7WUFDSCxDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUM7Z0JBQ2pDLElBQU0sSUFBRSxHQUFHLElBQUksV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUM5QixPQUFPLENBQUMsSUFBRSxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUM7b0JBQ3JCLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBRSxDQUFDLElBQUksRUFBRSxDQUFDLENBQUM7b0JBQ3JCLElBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztnQkFDWixDQUFDO1lBQ0gsQ0FBQztRQUNILENBQUM7SUFDSCxDQUFDO0lBRUQsd0JBQVMsR0FBVDtRQUNFLE1BQU0sQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRUQscUJBQU0sR0FBTjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLENBQUM7SUFDdEIsQ0FBQztJQUVELG9CQUFLLEdBQUw7UUFDRSxNQUFNLENBQUMsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRUQscUJBQU0sR0FBTjtRQUNFLElBQUksQ0FBQyxNQUFNLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQztRQUM5QixNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELG1CQUFJLEdBQUo7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELDBCQUFXLEdBQVg7UUFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztJQUNyQixDQUFDO0lBRUQsMEJBQVcsR0FBWDtRQUNFLElBQU0sS0FBSyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUMzQixFQUFFLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ3BCLE1BQU0sQ0FBQyxLQUFLLENBQUM7UUFDZixDQUFDO1FBQ0QsTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRUQsb0JBQUssR0FBTDtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ3JCLENBQUM7SUFFRCxzQkFBTyxHQUFQO1FBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7SUFDckIsQ0FBQztJQUVELHlCQUFVLEdBQVYsVUFBVyxNQUFtQjtRQUM1QixFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUMsQ0FBQyxDQUFDO1lBQ25CLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxNQUFNLENBQUMsQ0FBQztRQUN2QyxDQUFDO1FBQUMsSUFBSSxDQUFDLENBQUM7WUFDTixJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDeEMsQ0FBQztJQUNILENBQUM7SUFHTSxlQUFVLEdBQWpCLFVBQWtCLENBQVMsRUFBRSxNQUFtQjtRQUM5QyxJQUFNLEVBQUUsR0FBRyxJQUFJLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUM5QixPQUFPLENBQUMsRUFBRSxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUM7WUFDckIsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQztZQUN2QixFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDWixDQUFDO0lBQ0gsQ0FBQztJQUdNLGdCQUFXLEdBQWxCLFVBQW1CLENBQVMsRUFBRSxNQUFtQjtRQUMvQyxJQUFNLEVBQUUsR0FBRyxJQUFJLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUM5QixNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBUSxDQUFDO1FBQ3ZCLE9BQU8sQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLEVBQUUsQ0FBQztZQUNyQixJQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDcEIsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDWixLQUFLLEVBQUUsQ0FBUTtnQkFDZixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsQ0FBQyxDQUFDLENBQUM7b0JBQzNCLEtBQUssQ0FBQztnQkFDUixLQUFLLENBQUM7b0JBQ0osTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsRUFBRSxDQUFRLENBQUM7b0JBQ25DLEtBQUssQ0FBQztnQkFDUixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsR0FBRyxDQUFRLENBQUM7b0JBQ3BDLEtBQUssQ0FBQztnQkFDUixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsR0FBRyxDQUFRLENBQUM7b0JBQ3BDLEtBQUssQ0FBQztnQkFDUixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsR0FBRyxDQUFRLENBQUM7b0JBQ3BDLEtBQUssQ0FBQztnQkFDUixLQUFLLENBQUM7b0JBQ0osTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLEVBQVUsR0FBRyxDQUFRLENBQUM7b0JBQ3BDLEtBQUssQ0FBQztnQkFDUjtvQkFDRSxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2pCLENBQUM7WUFDRCxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDWixDQUFDO1FBQ0QsTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQVEsQ0FBQztJQUN6QixDQUFDO0lBR00sZ0JBQVcsR0FBbEIsVUFBbUIsQ0FBUyxFQUFFLE1BQW1CO1FBQy9DLElBQU0sRUFBRSxHQUFHLElBQUksV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQzlCLE9BQU8sQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLEVBQUUsQ0FBQztZQUNyQixJQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDcEIsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDVixLQUFLLEVBQUUsQ0FBUTtnQkFDZixLQUFLLEVBQUUsQ0FBUTtnQkFDZixLQUFLLEVBQUUsQ0FBUTtnQkFDZixLQUFLLEVBQUUsQ0FBUztnQkFDaEIsS0FBSyxFQUFFLENBQVE7Z0JBQ2YsS0FBSyxHQUFHLENBQVE7Z0JBQ2hCLEtBQUssR0FBRztvQkFDTixNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxDQUFDLENBQUMsQ0FBQztvQkFDM0IsS0FBSyxDQUFDO2dCQUNSLEtBQUssQ0FBQztvQkFDSixNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxFQUFFLENBQVEsQ0FBQztvQkFDbkMsS0FBSyxDQUFDO2dCQUNSLEtBQUssRUFBRTtvQkFDTCxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxHQUFHLENBQVEsQ0FBQztvQkFDcEMsS0FBSyxDQUFDO2dCQUNSLEtBQUssRUFBRTtvQkFDTCxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxHQUFHLENBQVEsQ0FBQztvQkFDcEMsS0FBSyxDQUFDO2dCQUNSLEtBQUssRUFBRTtvQkFDTCxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxHQUFHLENBQVEsQ0FBQztvQkFDcEMsS0FBSyxDQUFDO2dCQUNSLEtBQUssQ0FBQztvQkFDSixNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBVSxHQUFHLENBQVEsQ0FBQztvQkFDcEMsS0FBSyxDQUFDO2dCQUNSO29CQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDbkIsQ0FBQztZQUNELEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNaLENBQUM7SUFDSCxDQUFDO0lBRUQsc0JBQU8sR0FBUCxVQUFRLElBQVU7UUFDaEIsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLElBQUksQ0FBQyxDQUFDLENBQUM7WUFDekIsSUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQ3JELE1BQU0sQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDNUMsQ0FBQztRQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxJQUFJLFlBQVksSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLFlBQVksSUFBSSxDQUFDLE1BQU07ZUFDekQsSUFBSSxZQUFZLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO1lBQ3JDLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFDWCxDQUFDO1FBQUMsSUFBSSxDQUFDLENBQUM7WUFDTixNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDWixDQUFDO0lBQ0gsQ0FBQztJQUVELHFCQUFNLEdBQU4sVUFBTyxJQUFTO1FBQ2QsRUFBRSxDQUFDLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxDQUFDLENBQUM7WUFDbEIsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNkLENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLElBQUksQ0FBQyxDQUFDLENBQUM7WUFDaEMsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLEtBQUssSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUNyQyxDQUFDO1FBQ0QsTUFBTSxDQUFDLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCx1QkFBUSxHQUFSO1FBQ0UsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ25DLENBQUM7SUFFRCx1QkFBUSxHQUFSO1FBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7SUFDckIsQ0FBQztJQU9NLFVBQUssR0FBWjtRQUNFLE1BQU0sQ0FBQyxJQUFJLElBQUksQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDekIsQ0FBQztJQUVNLFlBQU8sR0FBZCxVQUFlLEtBQWE7UUFDMUIsRUFBRSxDQUFDLENBQUMsS0FBSyxDQUFDLE1BQU0sS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ3ZCLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBQ3BCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sQ0FBQyxJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1FBQ3pDLENBQUM7SUFDSCxDQUFDO0lBRU0sT0FBRSxHQUFULFVBQVUsS0FBZTtRQUN2QixFQUFFLENBQUMsQ0FBQyxLQUFLLFlBQVksSUFBSSxDQUFDLENBQUMsQ0FBQztZQUMxQixNQUFNLENBQUMsS0FBSyxDQUFDO1FBQ2YsQ0FBQztRQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxPQUFPLEtBQUssS0FBSyxRQUFRLENBQUMsQ0FBQyxDQUFDO1lBQ3JDLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQzdCLENBQUM7UUFBQyxJQUFJLENBQUMsQ0FBQztZQUNOLE1BQU0sSUFBSSxTQUFTLENBQUMsRUFBRSxHQUFHLEtBQUssQ0FBQyxDQUFDO1FBQ2xDLENBQUM7SUFDSCxDQUFDO0lBeEJlLGNBQVMsR0FBRyxDQUFDLENBQUM7SUFFZCxVQUFLLEdBQUcsSUFBSSxJQUFJLENBQUMsRUFBRSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQXVCdkQsV0FBQztDQUFBLEFBelBELENBQTBCLEtBQUssR0F5UDlCO1NBelBZLElBQUk7QUEwUGhCLElBQVksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDIn0=